import React from "react";
import "./OurValuesBox.css";
import { useLocation } from "react-router-dom";
export default function OurValuesBox({ Image, ImageAlt, Head, Title, Height, HeadWidthMob }) {
  const location = useLocation();
  const isArabic = location.pathname.endsWith("/ar");
  const isMobile = window.innerWidth <= 768;

  return (
    <>
      <div className={`OVBoxContainer ${isArabic ? "arabic" : "english"}`} style={{ height: Height }}>
        <div>
          <img src={Image} alt={ImageAlt} className="OVBoxImg" />
        </div>
        <div className={`OVBoxP1 TGLo32PxPC ${isArabic ? "arabic" : "english"}`} dir={isArabic ? "rtl" : "ltr"} style={{ width: isMobile ? HeadWidthMob : "" }}>
          {Head}
        </div>
        <div className={`OVBoxP2 TFut20PxPC ${isArabic ? "arabic" : "english"}`} dir={isArabic ? "rtl" : "ltr"}>
          {Title}
        </div>
      </div>
    </>
  );
}
